module.exports = __webpack_public_path__ + "assets/BisectAngleDetailed.8a3113fa7c8c2c31c9555991bda860f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/BisectAngleDetailed.png
// module id = 471
// module chunks = 0